import React, { useRef } from 'react'

import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { dependentsStep } from './DependentsStep'
import { employeeCostStep } from './EmployeeCostStep'
import { planDetailsStep } from './PlanDetailsStep'
import { summaryStep } from './SummaryStep'
import { initialHealthcarePlanData } from './state'
import { HealthcarePlanData } from './types'

interface Props {
  initialData?: HealthcarePlanData
  onSubmit: (data: HealthcarePlanData) => void
  onClose: () => void
  locale: string
  currency: string
}

const HealthcarePlanWizard: React.FC<Props> = ({
  initialData,
  onSubmit,
  onClose,
  locale,
  currency,
}) => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const steps: WizardStep<HealthcarePlanData>[] = useMemo(
    () => [
      planDetailsStep(),
      employeeCostStep(locale, currency),
      dependentsStep(locale, currency),
      summaryStep(),
    ],
    [locale, currency]
  )

  const initialWizardData = useRef(
    initialData
      ? initialData
      : {
          ...initialHealthcarePlanData,
          companyId: companyId,
        }
  )

  return (
    <Wizard.Modal
      title={i18n.t('benefits.healthcare.plan_wizard.title')}
      steps={steps}
      initialData={initialWizardData.current}
      onSubmit={onSubmit}
      bottomSpacing
      onClose={onClose}
    />
  )
}

export default HealthcarePlanWizard
